module.exports = __webpack_public_path__ + "pc/img/work_detail1.79469ab9.jpg";